import _ from "lodash";
import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import classes from "./Header.scss";
import { ToddleIcon, ChevronIcon, CreateAssessmentSvg } from "SvgComponents";
import { colors } from "Constants";
import I18nHOC from "UIComponents/I18nHOC";
import ScreenBaseComponent from "AppComponents/ScreenBaseComponent";
import LEPreview from "AppComponents/LEPreview";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";

const styles = {
  headerStyle: {
    padding: "8px 16px",
  },
};
class Header extends ScreenBaseComponent {
  constructor(props) {
    super(props);
  }

  myRef = React.createRef();

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside = e => {
    if (!this.myRef?.current?.contains(e.target)) {
      this.closeRightPane();
    }
  };

  onLEClick = () => {
    this.handleRightPane({ rightPane: "LE_PREVIEW" });
  };

  getRightPaneComponent = () => {
    const { assessmentId } = this.props;
    const { currentRightPane } = this.state;
    switch (currentRightPane) {
      case "LE_PREVIEW":
        return assessmentId ? (
          <LEPreview
            assessmentId={assessmentId}
            portalType={"PLANNER"}
            parentType={"JOURNAL"}
            showAttachmentItemV3={true}
            showBackButton={true}
            onClickBackButton={this.closeRightPane}
          />
        ) : null;
    }
  };

  render() {
    const {
      title,
      onBackClick,
      showTitle,
      rightContainerContent,
      LETitle,
      assessmentId,
      assessmentType,
      getCurrentAssessmentTypes,
      titleTextContainerStyle = {},
      screenHeaderContainerStyle = {},
      isGlobalHeaderEnabled,
    } = this.props;

    const currentAssessmentTypes = getCurrentAssessmentTypes();
    const LEAssessmentType = currentAssessmentTypes[assessmentType];
    const Icon = _.get(LEAssessmentType, "filledIcon") || CreateAssessmentSvg;
    const iconColor = _.get(
      LEAssessmentType,
      "filledIconColor",
      colors.blue400
    );

    const titleTextClasses = classNames({
      [classes.titleText]: !isGlobalHeaderEnabled,
      [classes.compactTitleText]: isGlobalHeaderEnabled,
    });

    const headerContainerClasses = classNames({
      [classes.container]: true,
      [classes.compactHeaderContainer]: isGlobalHeaderEnabled,
    });

    return (
      <div
        className={headerContainerClasses}
        onClick={this.handleClickOutside}
        ref={this.myRef}
        style={{
          ...screenHeaderContainerStyle,
          ...(isGlobalHeaderEnabled ? styles.headerStyle : {}),
        }}
      >
        <div className={classes.leftContainer}>
          <div
            className={classes.logoContainer}
            onClick={onBackClick}
            data-test-id="journal-postcreation-header-back"
          >
            <div className={classes.chevronIconContainer}>
              <ChevronIcon fill={colors.neutral400} />
            </div>
            {!isGlobalHeaderEnabled ? <ToddleIcon /> : null}
            {showTitle && (
              <h6 className={titleTextClasses} style={titleTextContainerStyle}>
                {title}
              </h6>
            )}
          </div>
          {assessmentId && (
            <div className={classes.leContainer} onClick={this.onLEClick}>
              <div className={classes.leIconContainer}>
                <Icon
                  width={20}
                  height={20}
                  fill={iconColor}
                  fill1={colors.white}
                />
              </div>
              <div className={classes.assessmentTitle}>{LETitle}</div>
            </div>
          )}
        </div>
        {rightContainerContent && (
          <div className={classes.rightContainer}>{rightContainerContent}</div>
        )}
        {this.renderRightPane()}
      </div>
    );
  }
}

const mapActionCreators = { getCurrentAssessmentTypes };

export default compose(
  I18nHOC({ resource: "common" }),
  connect(null, mapActionCreators)
)(Header);
